export type WishState = {
  items: any[];
};

export type WishListProductsGetter = Omit<any, "id">;

export const state: WishState = {
  items: [],
};
